<script setup lang="ts">
  import { ref, withDefaults, defineProps } from "vue";
  import createJobStatusSetting from "@/types/requests/createJobStatusSetting"
  import createJobStatusFilterItems from "@/types/requests/createJobStatusFilterItems"
  import Api from "@/services/api/ApiServiceFabrick";
  import { useAuth } from "@/services/user/Auth0UserProvider"

  const { loginWithRedirect } = useAuth();
  const downloading = ref<boolean>(false);
  const localDeliveryPlans = ref<any>({ delivery_plan_ids: [] });

  type Props = {
    showable: boolean;
    btnClass?: string;
    btnName?: string;
    type: string;
    operationOfficeId?: number;
    settings?: createJobStatusSetting;
    filterItems?: createJobStatusFilterItems;
    trips?: string[];
    disabled?: boolean;
    deliveryPlans?: Array<any>;
    addRequestParams?: (params) => any;
  };

  const props = withDefaults(defineProps<Props>(), {
    showable: false,
    disabled: false,
    addRequestParams: ((params) => { return params }),
  });

  const downloadFile = () => {
    downloading.value = true;

    let params = {
      operation_office_id: props.operationOfficeId ?? null,
      type: props.type,
      settings: props.settings ?? null,
      filter_items: props.filterItems ?? null,
      trips: props.trips ?? [],
    }
    params = props.addRequestParams(params)

    Api().createJobStatus(params).then((data) => {
      pollingJobStatus(data.id)
    }).catch((error) => {
      const res = error.response
      switch (res.status) {
        case 401:
          loginWithRedirect({ appState: { targetUrl: location.pathname } })
          break
        case 403:
          location.reload()
          break
        case 422:
      }
      downloading.value = false
    })
  }

  const pollingJobStatus = (id: number) => {
    const interval = setInterval(() => {
      Api().getJobStatus(id).then((res) => {
        if (res.status == "completed") {
          download(res.file_path)
          clearInterval(interval)
          downloading.value = false
        }
        if (res.status == "failed") {
          alert(res?.output_contents?.message)
          clearInterval(interval)
          downloading.value = false
        }
      })
    }, 3000)
  }

  const download = (path: string | null) => {
    if (!path) return;

    Api().fileDownload(path)
  }
</script>

<template>
  <v-btn
    v-show="showable"
    :class="btnClass"
    class="file-download-btn"
    @click="downloadFile"
    :loading="downloading"
    :style="{
      backgroundColor : disabled ? '#B3B8BB' : ''
    }"
    :disabled="disabled"
    >
    {{ btnName }}
  </v-btn>
</template>
